package pt.at.oss.kotlin.manual.storage.common.tradingnames

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * TradingNamesEntry Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class TradingNamesEntry(
    var name: String = ""
) : BaseRecord()
